import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Event } from '@cx-types/home';
import { NgIf, CurrencyPipe } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { EventDatePipe } from '../../pipes/event-date.pipe';

@Component({
    selector: 'cx-event-card',
    templateUrl: './event-card.component.html',
    styleUrls: ['./event-card.component.scss'],
    standalone: true,
    imports: [NgIf, NgbTooltip, CurrencyPipe, TranslateModule, EventDatePipe]
})
export class EventCardComponent implements OnInit {

  @Input() item: Event;
  @Input() squareBanner: boolean = false;

  @HostListener('click', ['$event.target'])
  onClick() {
    if(this.item?.cta_link != ""){
      window.location.href = this.item?.cta_link;
    }else{
      this.router.navigate(['/event', this.item.uri]);
    }

  }

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

}
